<style scoped lang="scss" type="text/scss">
    .robot-item-container {
        background-color: #F4F4F4;
        box-sizing: border-box;
        padding: 1rem 1rem 1rem 0;
        display: flex;
        width: calc(50% - 1rem);
        height: 9rem;

        .left-panel {
            width: 6rem;
            height: 100%;
            display: flex;
            flex-direction: column;
            color: #999;
            position: relative;

            &:after {
                content: '';
                position: absolute;
                right: .25rem;
                top: 10%;
                height: 80%;
                width: 1px;
                background-color: #DDD;
            }

            .icon-container {
                flex: 1;
                font-size: 3rem;
                display: flex;
                justify-content: center;
                align-items: center;
            }

            .text {
                height: 1.5rem;
                line-height: 0;
                text-align: center;
            }
        }

        .right-panel {
            flex: 1;
            box-sizing: border-box;
            padding-left: 1rem;
            display: flex;
            flex-direction: column;
            justify-content: center;

            .first-panel {
                display: flex;
                justify-content: space-between;
                align-items: center;
                margin-bottom: .5rem;

                .robot-name {
                    flex: 1;
                    color: #666;
                    font-size: 1.1rem;
                }
            }

            .volume-panel {
                margin: .25rem 0 .5rem 0;
                display: flex;
                align-items: center;
                color: #999;
                font-size: .75rem;

                .stub-item {
                    margin-left: .3rem;
                    margin-right: .3rem;

                    &:first-of-type {
                        margin-left: 0;
                    }
                }

                .stub-text {

                }
            }

            .introduce-panel {
                font-size: .8rem;
                color: #999;
                display: -webkit-box;
                -webkit-box-orient: vertical;
                -webkit-line-clamp: 2;
                max-height: 2.5rem;
                overflow: hidden;
            }
        }
    }
</style>

<template>
    <functional-card class="robot-item-container" :operable="editable"
                     @call-edit="callEdit" @call-remove="callRemove">
        <div class="left-panel">
            <div class="icon-container">
                <i class="icon">&#xe612;</i>
            </div>
            <span class="text">#{{ index }}</span>
        </div>
        <div class="right-panel">
            <div class="first-panel">
                <div class="robot-name">
                    <span>{{ info.name }}</span>
                </div>
            </div>
            <div class="volume-panel">
                <rectangular-text class="stub-item" bg-color="#999">长</rectangular-text>
                <span class="stub-text">{{ info.length }} mm</span>
                <rectangular-text class="stub-item" bg-color="#999">宽</rectangular-text>
                <span class="stub-text">{{ info.width }} mm</span>
                <rectangular-text class="stub-item" bg-color="#999">高</rectangular-text>
                <span class="stub-text">{{ info.height }} mm</span>
            </div>
            <div class="introduce-panel">
                {{ info.introduce }}
            </div>
        </div>
    </functional-card>
</template>

<script>
    import FunctionalCard from '../../../components/functional-card/index';
    import RectangularText from '../../../components/rectangular-text/index';

    export default {
        name: '',
        props: {
            index: {
                type: Number,
                default: 0
            },
            editable: {
                type: Boolean,
                default: false
            },
            info: {
                type: Object,
                default: () => {
                    return {};
                }
            }
        },
        components: {
            RectangularText,
            FunctionalCard
        },
        data () {
            return {};
        },
        methods: {
            callEdit (callback) {
                this.$emit('call-edit', callback);
            },
            callRemove (callback) {
                this.$emit('call-remove', callback);
            }
        }
    };
</script>
